<template>
    <div>
        <v-btn :loading="loading" @click="registerCard" width="350px" color="#eee" elevation="0" height="40px"
            class="d-flex align-center justify-center">
            <v-icon class="mr-2" color="primary">mdi-credit-card-outline</v-icon>
            <span>Pago automático mensual</span>
        </v-btn>

        <v-dialog v-model="showDialog"
        :fullscreen="$vuetify.breakpoint.mobile"
        max-width="70vw"
              width="100%"
        persistent
       >
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="closeDialog">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ $t('modules.portalalumno.payments.cardRegistration.view.cardRegistrationModalTitle') }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text class="pt-5">
                    <div v-if="error" class="error-message">
                        <v-alert type="error">{{ error }}</v-alert>
                    </div>
                    <div v-else-if="formUrl" class="flywire-form-container">
                        <iframe :src="formUrl" width="100%" height="100%" frameborder="0"
                            @load="formLoaded = true" :style="iframeStyle"></iframe>
                    </div>
                    <div v-else class="text-center py-6">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                        <div class="mt-2">{{ $t('common.loading') }}</div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- STATUS DIALOG -->
        <v-dialog v-model="showStatusDialog" max-width="500px">
            <v-card>
                <v-card-title class="headline">
                    <v-icon :color="statusType === 'success' ? 'success' : 'error'" class="mr-2">
                        {{ statusType === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle' }}
                    </v-icon>
                    {{ statusType === 'success' ? $t('modules.portalalumno.payments.cardRegistration.view.successTitle') : $t('modules.portalalumno.payments.cardRegistration.view.errorTitle') }}
                </v-card-title>
                <v-card-text>
                    <p>{{ statusMessage }}</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="closeStatusDialog">
                        {{ $t('modules.portalalumno.payments.cardRegistration.view.closeButton') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import baseUrl from '../../../../../../core/constants/uri';
import { mapGetters } from 'vuex';

export default {
    name: 'CardRegistrationButton',
    props: {
        resumen: Object
    },
    data() {
        return {
            loading: false,
            showDialog: false,
            error: null,
            formUrl: null,
            formLoaded: false,
            allowedOrigins: [
                'https://payment-checkout.demo.flywire.com',
                'http://localhost:8080',
                'https://payment-checkout.flywire.com'
            ],
            selectedRegister: null,
            showStatusDialog: false,
            statusType: 'success',
            statusMessage: '',
        }
    },
    computed: {
        ...mapGetters({
            studentRegister: 'commons/getStudentActualRegister'
        }),
        iframeStyle() {
            if (this.$vuetify.breakpoint.mobile) {
                return 'min-height: calc(100vh - 96px); height: calc(100vh - 96px);';
            } else if (this.$vuetify.breakpoint.tablet) {
                return 'min-height: calc(80vh - 32px); height: calc(80vh - 32px);';
            } else {
                return 'min-height: calc(70vh - 32px); height: calc(70vh - 32px);';
            }
        }
    },
    methods: {
        async registerCard() {
            try {
                this.loading = true;
                this.error = null;
                this.formUrl = null;

                const authToken = localStorage.getItem('access_token') ? JSON.parse(localStorage.getItem('access_token')) : '';
                const studentData = JSON.parse(localStorage.getItem('alumnoSeleccionado'))?.userData;

                if (!studentData) {
                    throw new Error(this.$t('modules.portalalumno.payments.cardRegistration.errorFetchingStudentData'));
                }

                this.selectedRegister = this.studentRegister;

                if (!this.selectedRegister) {
                    throw new Error(this.$t('modules.portalalumno.payments.cardRegistration.noStudentCareerSelected'));
                }

                const studentIdsList = [];
                let totalAmount = 0;

                if (this.resumen?.items?.subtotal?.items) {
                    this.resumen.items.subtotal.items.forEach(item => {
                        if (item.id) {
                            studentIdsList.push(item.id);
                        }
                        if (item.monto) {
                            totalAmount += parseFloat(item.monto);
                        }
                    });
                }

                const studentIdString = studentIdsList.join('-');

                const payload = {
                    first_name: studentData.name || '',
                    last_name: studentData.lastname || '',
                    address: studentData.address || '',
                    city: '',
                    country: studentData.nationality || '',
                    state: '',
                    phone: studentData.cellphone || studentData.phone || '',
                    email: studentData.email || '',
                    zip: '',
                    studentCareerId: this.selectedRegister,
                    studentId: studentIdString,
                    amount: totalAmount,
                    type: 'tokenization_and_pay'
                };

                const response = await fetch(`${baseUrl}/flywire/orders/subscription`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${authToken}`,
                    },
                    body: JSON.stringify(payload)
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || this.$t('modules.portalalumno.payments.cardRegistration.errorCreatingCheckout'));
                }

                const data = await response.json();

                if (data && data.hosted_form && data.hosted_form.url) {
                    this.formUrl = data.hosted_form.url;
                    this.showDialog = true;
                } else {
                    throw new Error(this.$t('modules.portalalumno.payments.cardRegistration.invalidCheckoutSession'));
                }
            } catch (error) {
                this.showStatusDialog = true;
                this.statusType = 'error';
                this.statusMessage = error.message || this.$t('modules.portalalumno.payments.cardRegistration.errorProcessingCard');
            } finally {
                this.loading = false;
            }
        },

        closeDialog() {
            this.showDialog = false;
            setTimeout(() => {
                this.formUrl = null;
                this.error = null;
                this.formLoaded = false;
            }, 300);
        },

        closeStatusDialog() {
            this.showStatusDialog = false;
            this.statusMessage = '';
            this.statusType = 'success';
        },

        handleFlywireMessage(event) {
            if (!this.allowedOrigins.includes(event.origin)) {
                return;
            }

            try {
                const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
                if (data.success === true && data.source === 'checkout_session') {
                    this.confirmCardRegistration(data);
                } else if (data.error) {
                    this.showStatusDialog = true;
                    this.statusType = 'error';
                    this.statusMessage = data.error.message || this.$t('modules.portalalumno.payments.cardRegistration.errorProcessingCard');
                }
            } catch (error) {
                this.showStatusDialog = true;
                this.statusType = 'error';
                this.statusMessage = this.$t('modules.portalalumno.payments.cardRegistration.errorProcessingCard');
            }
        },

        async confirmCardRegistration(data) {
            try {
                if (!data.confirm_url || !data.confirm_url.url) {
                    throw new Error(this.$t('modules.portalalumno.payments.cardRegistration.invalidCheckoutSession'));
                }

                const authToken = localStorage.getItem('access_token') ? JSON.parse(localStorage.getItem('access_token')) : '';

                const response = await fetch(`${baseUrl}/flywire/orders/confirm-session`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${authToken}`,
                    },
                    body: JSON.stringify({
                        url: data.confirm_url.url,
                        studentCareerId: this.selectedRegister,
                        state: 'ACTIVE'
                    })
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || this.$t('modules.portalalumno.payments.cardRegistration.errorConfirmingCard'));
                }

                this.showStatusDialog = true;
                this.statusType = 'success';
                this.statusMessage = this.$t('modules.portalalumno.payments.cardRegistration.view.successMessage');
                this.closeDialog();
                this.$emit('card-registered');
                this.$store.commit('commons/SET_SIGNED_USERDATA', true);
                this.$emit('changeStep', 'approved');

            } catch (error) {
                this.showStatusDialog = true;
                this.statusType = 'error';
                this.statusMessage = error.message || this.$t('modules.portalalumno.payments.cardRegistration.errorConfirmingCard');
            }
        }
    },
    mounted() {
        if (!this.selectedRegister && this.studentRegister) {
            this.selectedRegister = this.studentRegister;
        }

        window.addEventListener('message', this.handleFlywireMessage);
    },
    beforeDestroy() {
        window.removeEventListener('message', this.handleFlywireMessage);
    }
}
</script>

<style scoped>
.flywire-form-container {
    overflow: hidden;
}

.flywire-form-container iframe {
    border: none;
    width: 100%;
    height: 100%;
}

@media (min-width: 1264px) {
    .flywire-form-container {
        min-height: calc(70vh - 32px);
    }
}

@media (min-width: 960px) and (max-width: 1263px) {
    .flywire-form-container {
        min-height: calc(80vh - 32px);
    }
}

@media (max-width: 959px) {
    .flywire-form-container {
        min-height: calc(100vh - 96px);
    }
}

.error-message {
    margin: 20px 0;
}
</style>
